import { render, staticRenderFns } from "./UserDelete.vue?vue&type=template&id=66d1abb4&"
import script from "./UserDelete.vue?vue&type=script&lang=js&"
export * from "./UserDelete.vue?vue&type=script&lang=js&"
import style0 from "./UserDelete.vue?vue&type=style&index=0&id=66d1abb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports